export const ThreeDotsLoading = ({
  disableFullscreen,
  replaceImage,
}: {
  disableFullscreen?: boolean;
  replaceImage?: boolean;
}) => {
  const disableFullscreenClass = disableFullscreen ? '' : 'min-h-screen';
  const imageReplacementClass = replaceImage ? 'w-60 h-full' : '';

  return (
    <div className={`mx-auto py-3 max-xs:px-2 xs:px-3 ${disableFullscreenClass} ${imageReplacementClass}`}>
      <div className={`flex justify-center space-x-2 pt-4 ${disableFullscreen ? '' : 'pt-[35%]'}`}>
        <div className="h-3 w-3 animate-flash rounded-full bg-cornflowerblue"></div>
        <div className="animation-delay-200 h-3 w-3 animate-flash rounded-full bg-cornflowerblue"></div>
        <div className="animation-delay-400 h-3 w-3 animate-flash rounded-full bg-cornflowerblue"></div>
      </div>
    </div>
  );
};
